export const VISIBILITY_PATH_STARTING_INDEX = '/render/editor'.length;
